import http from '@/libs/http'

export default {
  find(id) {
    return http.get(`/cms/crud/${id}`).then(result => result.data)
  },
  findAll(options) {
    const limit = 10
    const params = Object.assign({
      limit,
      offset: (options.page - 1) * limit,
      sort_by: 'updated_at',
      order: 'desc'
    }, options)
    delete params.page
    return http.get('/cms/cruds', { params }).then(result => result.data)
  },
  create(model) {
    return http.post('/cms/cruds', model).then(result => result.data).catch(error => error)
  },
  update(model) {
    return http.put(`/cms/crud/${model.id}`, this._clean(model)).then(result => result.data)
  },
  delete(id) {
    return http.delete(`/cms/crud/${id}`).then(result => result.data)
  },
  checkCrudAlias(aliasPayload) {
    const payload = typeof aliasPayload === 'object' && aliasPayload !== null
      ? aliasPayload
      : { alias: aliasPayload }
    return http.post(`/cms/crud/check-alias`, payload).then(result => result.data.result)
  },
  _clean(model) {
    const m = Object.assign({}, model)
    delete m.id
    return m
  }
}
